import { atom } from 'jotai';
import { AtomsToHydrate } from '@/types/userConfigs';

export const atomsToHydrateAtom = atom<null | AtomsToHydrate>(null);

export const setAtomsToHydrateAtom = atom(null, (_, set, atomsToHydrate: AtomsToHydrate) => {
  atomsToHydrate.forEach(([atomToSet, value]) => {
    set(atomToSet, value);
  });
});
